import {StyleSheet, Platform} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load. Style-as-function entries are
// preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    root: {
      flex: 1,
      marginLeft: 20,
      marginRight: 20,
    },
    title: {
      textAlign: 'center',
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textPrimary,
    },
    inputTitleStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textMuted,
      marginTop: 30,
    },
    codeFieldRoot: {
      marginTop: 10,
    },
    cell: hasError => ({
      height: Platform.OS == 'web' ? 54 : 50,
      paddingVertical: Platform.OS == 'ios' ? 10 : 12,
      fontFamily: FONTS.regularFont,
      fontSize: 24,
      borderWidth: 1,
      borderColor: hasError ? colors.danger : colors.borderMuted,
      textAlign: 'center',
      borderRadius: 16,
      color: colors.textPrimary,
    }),
    mobileCell: {
      flex: 1,
      marginHorizontal: 5,
    },
    webCell: {
      width: 42,
      marginRight: 10,
    },
    leftButton: {
      flex: 1,
    },
    rightButton: {
      flex: 1,
      marginLeft: 16,
    },
    buttonsContainer: {
      marginTop: 16,
      marginBottom: 16,
      flexDirection: 'row',
    },
    accessoryContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: colors.backgroundMuted,
    },
    doneButton: {
      fontFamily: FONTS.mediumFont,
      color: colors.accent,
      fontSize: 16,
    },
    fullFlex: {
      flex: 1,
    },
  });

export default makeStyles;
